<div class="map-menu-item">
  <div class="header header--default">
    <h3 class="p-0 border-0">Points of Interest</h3>
  </div>
  <ul class="boundaries-list points-of-interest p-0 m-0" (click)="$event.stopPropagation()">
    <li mat-menu-item role="menuitemcheckbox" *ngFor="let point of pointOfInterest$ | async " class="map-layer">
      <label class="custom-control custom-checkbox boundaries-list__label"
             tabindex="0" *ngIf="selectedPointsOfInterest$ | async as selectedPointsOfInterest">
        <input type="checkbox"
               class="custom-control-input checkbox-default"
               [checked]="isChecked(selectedPointsOfInterest, point.key)"
               (change)="togglePointOfInterest($event, point.key)">
        <span class="custom-control-indicator"></span>
        <span class="layer-text">{{point.label}}</span>
      </label>
    </li>
  </ul>
</div>
